<template>
  <v-container fluid class="mt-0 pt-0">
    <v-row style="user-select:none" class="mt-0 pt-0">
      <v-col cols="12">
        <span class="menuTitle">Cartões de Crédito</span><br />
        <span class="menuSubtitle"
          >Gerencie todos os cartões de créditos utilizados.</span
        >
      </v-col>
    </v-row>
    <v-row style="user-select:none" justify="center" align-content="center">
      <v-col cols="12">
        <p class="text-center">EM BREVE</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "UserCards",
  components: {},
  data: () => ({}),
  computed: {},
  methods: {},
  mounted() {
    //
  }
};
</script>
<style>
.menuTitle {
  font-size: 20px;
  color: #132237;
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 3px #60ba8e45 solid;
}
.menuSubtitle {
  font-size: 14px;
  font-weight: 300;
  color: #000000ba;
}
</style>
